export default __webpack_public_path__ + "resources/icons/d400-5752.webp";